import Fingerprint2 from 'fingerprintjs2'

const CACHE_ID = 'app:fp'
const timeout = 500

let promise: Promise<string> | null = null

function createHash (components: Fingerprint2.Component[]) {
  const values = components.map((component) => component.value)
  return Fingerprint2.x64hash128(values.join(''), 31)
}

export function getFingerprint (): Promise<string> {
  if (process.env.SERVER) {
    return Promise.resolve('')
  }
  if (!promise) {
    promise = new Promise<string>((resolve) => {
      const hash = localStorage.getItem(CACHE_ID)
      const done = (components: Fingerprint2.Component[]) => {
        const newHash = createHash(components)
        localStorage.setItem(CACHE_ID, newHash)
        resolve(newHash)
      }
      if (hash) {
        resolve(hash)
      } else if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => {
          Fingerprint2.getPromise().then(done)
        }, { timeout })
      } else {
        setTimeout(() => {
          Fingerprint2.getPromise().then(done)
        }, timeout)
      }
    })
  }
  return promise
}
